import type { FullRecord } from "@shared/types";
import { SL } from "../constants";
import { fmtF } from "../util";

export function exportExcel(records: FullRecord[]): void {
  if (typeof window.XLSX === "undefined") {
    alert("Aguarde e tente novamente.");
    return;
  }
  const rows = records.map(d => ({
    "Data": d.data || "",
    "Responsável": d.resp || "",
    "Cliente": d.cliente || "",
    "Ramo": d.ramo || "",
    "Corretor / Indicação": d.corretor || "",
    "Status": SL[d.status] || d.status || "",
    "Motivo não fechamento": d.motivo_perda || "",
    "Detalhe motivo": d.motivo_det || "",
    "Reativar em": d.reativ_data ? fmtF(d.reativ_data) : "",
    "Próximo contato": d.prox_data ? fmtF(d.prox_data) : "",
    "Motivo próximo contato": d.prox_mot || "",
    "Observação": d.obs || "",
    "Documentos": (d.docs || []).map(doc => `${doc.nome}: ${doc.url}`).join(" | "),
    "Histórico": (d.historico || []).map(h => `[${h.dt}] ${h.txt}`).join(" | "),
  }));
  const ws = window.XLSX.utils.json_to_sheet(rows);
  ws["!cols"] = [{ wch: 10 }, { wch: 12 }, { wch: 28 }, { wch: 14 }, { wch: 24 }, { wch: 18 }, { wch: 26 }, { wch: 30 }, { wch: 12 }, { wch: 14 }, { wch: 26 }, { wch: 44 }, { wch: 50 }, { wch: 70 }];
  const wb = window.XLSX.utils.book_new();
  window.XLSX.utils.book_append_sheet(wb, ws, "Prospecções");
  const d = new Date();
  window.XLSX.writeFile(wb, `prospeccoes_ss_${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, "0")}${String(d.getDate()).padStart(2, "0")}.xlsx`);
}
